module.exports = __webpack_public_path__ + "img/search-oliver3.3b60563a.png";